import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-confirm-popup',
    templateUrl: './confirm-popup.component.html',
    styleUrls: ['./confirm-popup.component.scss'],
    standalone: false
})
export class ConfirmPopupComponent implements OnInit {
  onConfirm = new EventEmitter();
  public processing;
  public error;
	public title = '';
	public message = '';
	responseError = new EventEmitter();
  responseStatus = new EventEmitter();
  errors:any;
  status:any;

  constructor(private dialogRef: MatDialogRef<ConfirmPopupComponent>,
							@Inject(MAT_DIALOG_DATA) data:any ) {
    this.processing = false;
		this.error = '';
		this.title = data.title;
		this.message = data.message;
  }

  ngOnInit(): void {
    this.responseError.subscribe(result=> {
        this.errors = [result];
        this.processing = false;
    });
    this.responseStatus.subscribe(result=> {
      this.status = result;
      console.log(result);
    });
  }

  ngOnChange(): void {
  }

	cancel() {
		this.dialogRef.close(false);
	}

  confirm() {
  	if(!this.processing){
			this.processing = true;
			this.onConfirm.emit(true);
		}
  }
}
